import React from "react";
import withProviders from "../../hooks/withProviders";
import AdministrationReminders from "../../features/administrationreminders";
import { FilterProvider, AdministrationRemindersDefaultFilters } from "../../hooks/FilterContext";

const AdministrationRemindersPage = () => <AdministrationReminders />

export default withProviders([FilterProvider, { defaultFilters: AdministrationRemindersDefaultFilters }])(AdministrationRemindersPage);